export type ProductIdMigration = {
  legacyId: string
  id: string
  liveName: string
  productFamily: 'Brownie Cookie Sandwich' | 'Massive Stuffed Cookie' | 'Brownie'
}

export const PRODUCT_ID_MIGRATIONS = [
  { legacyId: 'vanilla', id: 'bcs-chocolate', liveName: 'Chocolate', productFamily: 'Brownie Cookie Sandwich' },
  { legacyId: 'blueberry', id: 'bcs-vanilla', liveName: 'Vanilla', productFamily: 'Brownie Cookie Sandwich' },
  { legacyId: 'chocolate', id: 'bcs-pineapple', liveName: 'Pineapple', productFamily: 'Brownie Cookie Sandwich' },
  { legacyId: 'toasted-coconut', id: 'bcs-cookie-dough', liveName: 'Cookie Dough', productFamily: 'Brownie Cookie Sandwich' },
  { legacyId: 'biscoff', id: 'msc-og-chocolate', liveName: 'O.G Chocolate', productFamily: 'Massive Stuffed Cookie' },
  { legacyId: 'banana-caramel-pb', id: 'msc-caramel', liveName: 'Caramel', productFamily: 'Massive Stuffed Cookie' },
  { legacyId: 'bueno', id: 'msc-raspberry-white-chocolate-cheesecake', liveName: 'Raspberry White Chocolate Cheesecake', productFamily: 'Massive Stuffed Cookie' },
  { legacyId: 'og-chocolate', id: 'brownie-ny-double-choc', liveName: 'NY Style Double Choc', productFamily: 'Brownie' },
] as const satisfies readonly ProductIdMigration[]

const LEGACY_TO_CURRENT = new Map<string, ProductIdMigration>(PRODUCT_ID_MIGRATIONS.map((item) => [item.legacyId, item]))
const CURRENT_TO_LEGACY = new Map<string, string>(PRODUCT_ID_MIGRATIONS.map((item) => [item.id, item.legacyId]))

export function normalizeProductId(productId: string): string {
  return LEGACY_TO_CURRENT.get(productId)?.id ?? productId
}

export function legacyProductId(productId: string): string | null {
  return CURRENT_TO_LEGACY.get(productId) ?? null
}

export function productIdMigration(productId: string) {
  return LEGACY_TO_CURRENT.get(productId) ?? null
}

export function isLegacyProductId(productId: string): boolean {
  return LEGACY_TO_CURRENT.has(productId)
}

function normalizeName(value: string) {
  return value.replace(/\s+/g, ' ').trim().toLocaleLowerCase('en-NZ')
}

export function legacySelectionMatchesCurrentIdentity(productId: string, productName: string): boolean {
  const migration = productIdMigration(productId)
  if (!migration) return true
  return normalizeName(productName) === normalizeName(migration.liveName)
}

export function normalizedProductIdForSnapshot(productId: string, productName: string): string {
  const migration = productIdMigration(productId)
  if (!migration) return productId
  return legacySelectionMatchesCurrentIdentity(productId, productName) ? migration.id : productId
}
